import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import _ from 'lodash';
import * as commonReducers from '@common/store/reducers';
import sagaMiddleware from './saga';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const nestedReducers = (reducers) => {
  let keys = Object.keys(reducers);
  keys.forEach((key) => {
    let obj = reducers[key];
    if (!_.isFunction(obj)) {
      reducers[key] = nestedReducers(obj);
    }
  });
  return combineReducers(reducers);
};

const createAppStore = (reducerMap) => {
  const injectAsyncReducers = (store, name, reducers) => {
    _.set(store.asyncReducers, name, reducers);
    let allReducers = { ..._.cloneDeep(store.asyncReducers), ...reducerMap };
    let finalReducers = nestedReducers(allReducers);
    store.replaceReducer(finalReducers);
  };

  const store = createStore(combineReducers(reducerMap), composeEnhancers(applyMiddleware(sagaMiddleware)));

  store.asyncReducers = {};

  store.registerDynamicModule = (name, reducers) => {
    injectAsyncReducers(store, name, reducers);
  };

  return store;
};

const importReducers = (requireComponent) => {
  requireComponent.keys().forEach((fileName) => {
    requireComponent(fileName);
  });
};

const createdStore = createAppStore(commonReducers);

export { importReducers };
export default createdStore;
